import React from 'react';
import './header.css';

const Header = () => {
	return (
        <div className="header-container">
            <div className="header m-auto">
                <a href="">Home</a>
                <a href="#footer">Talk to us</a>
            </div>
        </div>
    )
}

export default Header;
